'use client'

import React from 'react'
import styled, {createGlobalStyle, css} from 'styled-components'

import theme from '@/src/config/theme'

import errorPic from '@/src/shared/assets/media/error-pic.jpg'

import Button from './button'

interface IProps {
  status: number
  children?: any
  reset?: () => void
  global?: boolean
}

const GlobalStyles = createGlobalStyle`
    body {
        height: 100%;
    }
`

const Error = ({status, children, global = false}: IProps) => {
  return (
    <>
      <title>Ошибка {status}</title>
      <GlobalStyles />
      <Wrapper>
        <Body>
          <Container $imgSrc={errorPic.src} $global={global}>
            <Title>Ошибка {status}</Title>

            <ErrorBlock>
              {children}
            </ErrorBlock>

            <ButtonWrapper>
              <Button outlined primary href="/">
                На главную
              </Button>
            </ButtonWrapper>
          </Container>
        </Body>
      </Wrapper>
    </>
  )
}

const Wrapper = styled.div`
  display: table;
  width: 100%;
  flex: 1;
  height: 100%;
  word-break: break-word;
  white-space: normal;
`

const ButtonWrapper = styled.div`
  display: flex;
`

const Container = styled.div<{$imgSrc: string; $global?: boolean}>`
  height: 100%;
  background: url(${props => props.$imgSrc}) no-repeat 60% 100% / 80% auto;
  background-size: contain;
  max-width: ${theme.sizes.container}px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  padding: 0 10px;

  ${props =>
    props.$global &&
    css`
      min-height: 100vh;
    `}
`

const ErrorBlock = styled.div`
  margin: 20px 0;

  p {
    font-weight: 450;
  }
`

const Body = styled.div`
  display: table-cell;
  vertical-align: middle;
  height: 80%;
`

const Title = styled.h1`
  padding: 20px 0;

  font-size: 124px;
  font-weight: 450;

  line-height: 80%;
  @media only screen and (max-width: 480px), only screen and (max-device-width: 480px) {
    font-size: 80px;
  }
`

export default Error
